import * as React from "react";
import "./import-viewing-panel.scss";

export const ImportViewingPanel = ({onEdit}) => (
    <div className="import-viewing-panel-a5t">
        <div className="title">
            <div className="label" xd-qa-type="label" xd-qa-name="Addressing Options">
                Addressing Options
            </div>
            <a className="edit-action" onClick={onEdit} xd-qa-type="link" xd-qa-name="Edit">
                Edit
            </a>
        </div>
        <div className="sub-title" xd-qa-type="label" xd-qa-name="Use recipient name">
            Use recipient name
        </div>
    </div>
);

